export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9841.f74be5b2.jpg";